import { all, fork } from "redux-saga/effects";

import { mailboxesSagas } from "store/entities/mailboxes/sagas";

import { agentsSagas } from "./agents/sagas";
import { applicationSettingsSaga } from "./application-settings/sagas";
import { applicationsSagas } from "./applications/sagas";
import { billingSaga } from "./billing/sagas";
import { cannedResponsesSagas } from "./canned-responses/sagas";
import { contactFormsSaga } from "./contact-forms/sagas";
import { creditCardSaga } from "./credit-card/sagas";
import { customFieldsSagas } from "./custom-fields/sagas";
import { viewsSagas } from "./custom-views/sagas";
import { emailDomainsSagas } from "./email-domains/sagas";
import { emailTemplateSagas } from "./email-template/sagas";
import { integrationsSagas } from "./integrations/sagas";
import { invoiceSagas } from "./invoices/sagas";
import { licenseSagas } from "./license/sagas";
import { recurlySaga } from "./recurly/sagas";
import { replyAddressSagas } from "./reply-addresses/sagas";
import reportsSaga from "./reports/sagas";
import { rulesSagas } from "./rules/sagas";
import { spamSagas } from "./spam/sagas";
import { subscriptionsSaga } from "./subscriptions/sagas";
import { tagsSagas } from "./tags/sagas";
import { teamsSagas } from "./teams/sagas";
import { ticketSagas } from "./tickets/sagas";
import { transactionSagas } from "./transaction/sagas";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* entitiesSagas() {
  yield all([
    fork(agentsSagas),
    fork(cannedResponsesSagas),
    fork(emailDomainsSagas),
    fork(teamsSagas),
    fork(licenseSagas),
    fork(mailboxesSagas),
    fork(tagsSagas),
    fork(ticketSagas),
    fork(viewsSagas),
    fork(subscriptionsSaga),
    fork(creditCardSaga),
    fork(billingSaga),
    fork(recurlySaga),
    fork(reportsSaga),
    fork(invoiceSagas),
    fork(integrationsSagas),
    fork(transactionSagas),
    fork(replyAddressSagas),
    fork(rulesSagas),
    fork(emailTemplateSagas),
    fork(contactFormsSaga),
    fork(spamSagas),
    fork(applicationsSagas),
    fork(customFieldsSagas),
    fork(applicationSettingsSaga),
  ]);
}
